// 3p
import { connect } from 'react-redux';
import { Link } from 'react-router';
import React, { PropTypes } from 'react';

// Fp
import { getPageIndex } from '../../store/reducers/pages';
import { FETCH_PAGE_INDEX, LOGOUT } from '../../constants';
import ActionButton from '../ActionButton';

const Header = (props) => {
  return (
    <div className="mb5 pt5">{props.children}</div>
  )
}

class Index extends React.Component {
  static propTypes = {
    wide: PropTypes.bool
  }

  static defaultProps = {
    wide: false
  }

  componentWillMount() {
    this.props.fetchPageIndex()
  }

  render() {
    const {pages, onLogout, wide} = this.props;

    let classNames = 'bg-near-white pl4 flex flex-column justify-between';

    if (wide) {
      classNames += ' fg1';
    } else {
      classNames += ' w5';
    }

    return (
      <div className={classNames}>
        <div>
          <Header>
            <ActionButton>
              <Link to="/pages/new">New Page</Link>
            </ActionButton>
          </Header>

          <ul className="list ma0 pa0 f6">
            {pages.map((page, index) =>
              <IndexItem key={page.id} page={page} index={index} total={pages.length} />)}
          </ul>
        </div>

        <div className="mb3 mt5">
          <ActionButton onClick={onLogout}>Logout</ActionButton>
        </div>
      </div>
    )
  }
}

const isLast = (index, total) => index < total - 1;
const isFirst = (index) => index === 0;

const IndexItem = ({page, index, total}) => {
  const classNames = {
    li: isLast(index, total) ? 'bb b--light-gray' : '',
    link: isFirst(index)
      ? 'db link dark-gray pb2'
      : 'db link dark-gray pv2'
  }

  return (
    <li className={classNames.li}>
      <Link to={`/pages/${page.id}`} className={classNames.link}>{page.title}</Link>
    </li>
  )
}

const mapStateToProps = (state, ownProps) => {
  const pages = getPageIndex(state.pages);

  return { pages }
}

const mapDispatchToProps = (dispatch) => {
  return {
    fetchPageIndex: () => dispatch({ type: FETCH_PAGE_INDEX }),
    onLogout: () => dispatch({ type: LOGOUT })
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(Index);


/** WEBPACK FOOTER **
 ** ./src/components/pages/Index.js
 **/